import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getCall } from './api-calls/apicalls.service';

@Injectable({
    providedIn: 'root',
})
export class DealTriggerService {
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        }),
    };

    constructor(public _http: HttpClient) {}

    /**
     * Returns httpOptions - headers without content-type
     */
    getHeaderWOCT(): any {
        return {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            }),
        };
    }

    saveTriggerFile(data: any) {
        const url = getCall('trigger-actions', null, {
            access: localStorage.getItem('user-access'),
        });

        return this._http.post(url, data, this.getHeaderWOCT());
    }

    saveTrigger(data: any) {
        const url = getCall('trigger-actions', null, {
            access: localStorage.getItem('user-access'),
        });
        data['access'] = localStorage.getItem('user-access');

        return this._http.post(url, data, this.httpOptions);
    }
}
